import { ConfiguredMailersSection } from './configured-mailers-section';
import { EmailHistorySection } from './email-history-section';

/**
 * Mailer tab — the customer's configured mailers (recipients + purposes +
 * sendable state) stacked above the server-paginated email delivery history.
 * Read-only; ported 1-1 from the legacy datacentral-client Mailer module.
 */
export default function MailerTab({ customerId }: { customerId: number }) {
  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
      <ConfiguredMailersSection customerId={customerId} />
      <EmailHistorySection customerId={customerId} />
    </div>
  );
}
